import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=fa83c128&"
import script from "./order_detail.vue?vue&type=script&lang=js&"
export * from "./order_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=fa83c128&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports